/**
 * VAT Free countdown.
 *
 * Repaints every [data-vatfree-deadline] element on the page once a second.
 *
 * Deliberately stateless: each tick re-queries the DOM and holds no reference
 * to anything it painted. That matters because the cart drawer replaces its
 * own markup wholesale — CartDrawer.renderContents() overwrites
 * #CartDrawer.innerHTML on every add, and CartDrawerItems overwrites
 * .drawer__inner.innerHTML on every quantity change. A timer that cached its
 * element would be left painting a detached node after the first add to cart;
 * this one simply finds whatever is mounted now.
 *
 * Covered by tests/vat-free-timer.test.mjs — run `node --test tests/`.
 */
(function () {
  'use strict';

  // The snippet renders on the PDP and inside the cart drawer, so this file can
  // be evaluated more than once. Never start a second clock.
  if (window.__vatFreeTimer) return;

  var SELECTOR = '[data-vatfree-deadline]';
  var BANNER = '[data-vatfree-banner]';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /** ms remaining -> "4d 10h 59m 56s", dropping empty leading units. */
  function format(msLeft) {
    var total = Math.floor(msLeft / 1000);
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;

    if (days > 0) return days + 'd ' + pad(hours) + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
    if (hours > 0) return pad(hours) + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
    return pad(minutes) + 'm ' + pad(seconds) + 's';
  }

  function tick(now) {
    var nodes = document.querySelectorAll(SELECTOR);

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // The deadline carries an explicit UTC offset. Without it the string
      // would be parsed in the visitor's own timezone and read wrong abroad.
      var deadline = Date.parse(el.getAttribute('data-vatfree-deadline'));

      // A malformed date must leave the markup alone rather than print "NaN".
      if (isNaN(deadline)) continue;

      var remaining = deadline - now;

      if (remaining <= 0) {
        // Hide the whole banner, not just the digits, so no stranded copy is
        // left promising an offer that has ended. Liquid already refuses to
        // render past the deadline; this covers a page left open across it.
        var host = el.closest(BANNER) || el;
        host.hidden = true;
        continue;
      }

      var text = format(remaining);
      // Only touch the DOM when the rendered second actually changed.
      if (el.textContent !== text) el.textContent = text;
    }
  }

  window.__vatFreeTimer = { tick: tick, format: format };

  tick(Date.now()); // paint immediately rather than showing a blank first second
  setInterval(function () {
    tick(Date.now());
  }, 1000);
})();
